export default "__VITE_ASSET__r3iLfhpJ__"